// import {Country} from './invoice.model';

const Orders = [
    {
      orderId: '#VZ2101',
      customer: 'Frank Hook',
      product: 'Puma Tshirt',
      orderDate: '20 Dec, 2021',
      time: '02:21 AM',
      amount: '654',
      payment: 'Mastercard',
      status: 'PENDING',
      isSelected:false
    },
    {
      orderId: '#VZ2102',
      customer: 'Rickey Teran',
      product: 'Adidas Sneakers',
      orderDate: '16 Dec, 2021',
      time: '03:41 PM',
      amount: '354',
      payment: 'Paypal',
      status: 'CANCELLED',
      isSelected:false
    },
    {
      orderId: '#VZ2103',
      customer: 'James Price',
      product: '350 ml Glass Grocery Container',
      orderDate: '28 Nov, 2021',
      time: '11:33 AM',
      amount: '829',
      payment: 'Visa',
      status: 'INPROGRESS',
      isSelected:false
    },
    {
      orderId: '#VZ2104',
      customer: 'Nettie Deloatch',
      product: 'American egale outfitters Shirt',
      orderDate: '22 Nov, 2021',
      time: '07:45 PM',
      amount: '142',
      payment: 'COD',
      status: 'PENDING',
      isSelected:false
    },
    {
      orderId: '#VZ2105',
      customer: 'Thomas Taylor',
      product: 'Galaxy Watch4',
      orderDate: '12 Nov, 2021',
      time: '10:19 PM',
      amount: '408',
      payment: 'Mastercard',
      status: 'PICKUPS',
      isSelected:false
    },
    {
      orderId: '#VZ2106',
      customer: 'James Price',
      product: 'Apple iPhone 12',
      orderDate: '05 Nov, 2021',
      time: '11:47 AM',
      amount: '1240',
      payment: 'Visa',
      status: 'INPROGRESS',
      isSelected:false
    },
    {
      orderId: '#VZ2107',
      customer: 'Nancy Martino',
      product: 'Funky Prints T-shirt',
      orderDate: '31 Oct, 2021',
      time: '08:55 PM',
      amount: '180',
      payment: 'COD',
      status: 'RETURNS',
      isSelected:false
    },
    {
      orderId: '#VZ2108',
      customer: 'Alexis Clarke',
      product: 'USB Flash Drive Personalized with 3D Print',
      orderDate: '25 Oct, 2021',
      time: '05:33 AM',
      amount: '247',
      payment: 'Paypal',
      status: 'DELIVERED',
      isSelected:false
    },
    {
      orderId: '#VZ2109',
      customer: 'Donald Palmer',
      product: 'Oxford Button-Down Shirt',
      orderDate: '19 Oct, 2021',
      time: '12:43 AM',
      amount: '373',
      payment: 'Visa',
      status: 'PICKUPS',
      isSelected:false
    },
    {
      orderId: '#VZ2110',
      customer: 'Henry Baird',
      product: 'Classic Short Sleeve Shirt',
      orderDate: '13 Oct, 2021',
      time: '01:20 PM',
      amount: '342',
      payment: 'Mastercard',
      status: 'INPROGRESS',
      isSelected:false
    },
    {
      orderId: '#VZ2111',
      customer: 'Diana Kohler',
      product: 'Half Sleeve T-Shirts (Blue)',
      orderDate: '01 Oct, 2021',
      time: '03:08 AM',
      amount: '874',
      payment: 'Visa',
      status: 'DELIVERED',
      isSelected:false
    },
    {
      orderId: '#VZ2112',
      customer: 'Alexis Clarke',
      product: 'Noise Evolve Smartwatch',
      orderDate: '29 Sep, 2021',
      time: '04:24 AM',
      amount: '1021',
      payment: 'Mastercard',
      status: 'CANCELLED',
      isSelected:false
    }
  ];
  
  export { Orders };
  